module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d636d4676e9b68ff0a06f97ec1010ccd.png";